import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { environment } from '../../../../../common/environments/environment';
import { Auction} from '../../../../../common/interfaces';
import { AuthService } from '../auth/auth-service.service';
import { CrudHttpService } from '../crud-http/crud-http.service';

@Injectable()
export class AuctionHttpService extends CrudHttpService<Auction> {

  public api: string = environment.microservices.agrilio;

  constructor(db: AngularFirestore,  _http: HttpClient,  _auth: AuthService) {
    super(environment.collections.auction, db, _http, _auth);
    this.path = environment.collections.auction;
  }

}
